import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { formatACFT, formatGallons } from '../../dwriUtils';

const DwriPeakMonthSection = ({ peakMonthData, loading, error }) => {
    if (error) return <p className="text-danger">Error loading peak month data.</p>;
    if (loading && peakMonthData.length === 0) return <p>Loading...</p>;

    const sorted = [...peakMonthData].sort((a, b) => b.historyYear - a.historyYear);

    return (
        <>
            <Row>
                <Col><span><b>Peak Month Data</b></span></Col>
            </Row>
            <div className="table-responsive">
                <Row className='dwri-peak-month-header gx-0'>
                    <Col className='dwri-table-header-cell'><span><b>Year</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Peak Month (ACFT)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Peak Month (Gal)</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Days in Month</b></span></Col>
                    <Col className='dwri-table-header-cell'><span><b>Gallons/Day</b></span></Col>
                </Row>
                {sorted.map((peak, index) => (
                    <Row key={index} className={`dwri-peak-month-row gx-0 ${index % 2 === 0 ? 'is-even' : 'is-odd'}`}>
                        <Col className='dwri-table-cell'><span>{peak.historyYear}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatACFT(peak.peakMonthDemandACFT)}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(peak.peakMonthDemandGallons)}</span></Col>
                        <Col className='dwri-table-cell'><span>{peak.daysInMonth}</span></Col>
                        <Col className='dwri-table-cell'><span>{formatGallons(peak.gallonsPerDay)}</span></Col>
                    </Row>
                ))}
            </div>
            <br />
        </>
    );
};

export default DwriPeakMonthSection;
